import { type CustomTooltipProps } from "ag-grid-react"

import { Card, CardContent, CardTitle } from "~/components/reusable/Card"

export default function HeaderTooltip(props: CustomTooltipProps & { children?: React.ReactNode }) {
  if (props.value !== "") {
    return (
      <Card className="w-full max-w-[400px]">
        <CardContent>
          <CardTitle>{props.value}</CardTitle>
          {props.children}
        </CardContent>
      </Card>
    )
  }
  return null
}
